
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $f9926d7b37c1be84$exports = {};

$parcel$export($f9926d7b37c1be84$exports, "spectrum-Image-img", function () { return $f9926d7b37c1be84$export$3238177972e11200; }, function (v) { return $f9926d7b37c1be84$export$3238177972e11200 = v; });
var $f9926d7b37c1be84$export$3238177972e11200;
$f9926d7b37c1be84$export$3238177972e11200 = `tX8u6G_spectrum-Image-img`;


export {$f9926d7b37c1be84$exports as default};
//# sourceMappingURL=image_vars_css.mjs.map
